<template>

    <cms-view>

        <cms-heading title="Logger types" icon="magicon-dots-hr">
            <cms-button color="positive" icon="magicon-plus" route="logger-type-add" v-if="userIsAdmin">Toevoegen</cms-button>
            <cms-searchbar v-model="searchQuery"></cms-searchbar>
        </cms-heading>

        <cms-table-panel v-spinner="loading" :item-count="loggerTypes.totalCount || 0" :items-per-page="itemsPerPage" @page="offset = arguments[0]" :placeholder="!loggerTypes.items || !loggerTypes.items.length" :clickable="userIsAdmin">
            <cms-table-header>
                <cms-th field="title" v-model="sort">Titel</cms-th>
                <cms-th field="loggerPrice" v-model="sort">Loggerkosten</cms-th>
                <cms-th field="failurePrice" v-model="sort">Storingskosten</cms-th>
                <cms-th field="usagePrice" v-model="sort">Portalkosten</cms-th>
                <cms-th field="backofficePrice" v-model="sort">Backoffice kosten</cms-th>
                <cms-th field="manualRoundPrice" v-model="sort">Handmeetrondekosten</cms-th>
                <cms-th field="createdAt" v-model="sort">Aanmaakdatum</cms-th>
                <cms-th></cms-th>
            </cms-table-header>
            <tr v-for="type in loggerTypes.items" @click="editLoggerType(type)">
                <td>{{ type.title }}</td>
                <td v-if="type.loggerPrice !== null">&euro; {{ type.loggerPrice | number }}</td><td v-else></td>
                <td v-if="type.failurePrice !== null">&euro; {{ type.failurePrice | number }}</td><td v-else></td>
                <td v-if="type.usagePrice !== null">&euro; {{ type.usagePrice | number }}</td><td v-else></td>
                <td v-if="type.backofficePrice !== null">&euro; {{ type.backofficePrice | number }}</td><td v-else></td>
                <td v-if="type.manualRoundPrice !== null">&euro; {{ type.manualRoundPrice | number }}</td><td v-else></td>
                <td>{{ type.createdAt | date('LL') }}</td>
                <td class="actions" @click.stop>
                    <cms-link icon="magicon-edit" v-tooltip="'Wijzigen'" :to="{ name: 'logger-type-edit', params: { id: type.id } }" v-if="userIsAdmin" />
                </td>
            </tr>
        </cms-table-panel>

    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import gql from 'graphql-tag'

    import LoggerTypeQueries from 'app/queries/LoggerTypeQueries'
    import UserRole from 'app/enums/UserRole'

    @Component({

        name: 'logger-types',
        apollo: {

            loggerTypes: LoggerTypeQueries.all({

                fetchPolicy: 'cache-and-network',
                variables(){

                    return {

                        offset: this.offset,
                        limit: this.itemsPerPage,
                        filter: null,
                        sortField: this.sort.field,
                        sortDirection: this.sort.direction,
                        search: this.searchQuery
                    }
                }
            })
        }
    })
    export default class LoggerTypes extends Vue
    {
        static SORT_STORAGE_KEY = "LoggerTypesSort";
        static SEARCH_STORAGE_KEY = "LoggerTypesSearch";

        data(){

            return {

                loggerTypes: {},
                loading: 0,

                offset: 0,
                itemsPerPage: 20,
                searchQuery: this.$storage.getSession(LoggerTypes.SEARCH_STORAGE_KEY, null),
                sort: this.$storage.getSession(LoggerTypes.SORT_STORAGE_KEY, {
                    field: 'title',
                    direction: 'ASC'
                })
            }
        }

        created(){

            this.$watch('sort', (sort) => this.$storage.setSession(LoggerTypes.SORT_STORAGE_KEY, sort));
            this.$watch('searchQuery', (searchQuery) => this.$storage.setSession(LoggerTypes.SEARCH_STORAGE_KEY, searchQuery || ''));

            // Reset paging when searching
            this.$watch('searchQuery', () => {
                this.offset = 0;
            });
        }

        breadcrumb(){

            return 'Logger types';
        }

        editLoggerType(type){

            if(!this.userIsAdmin){
                return;
            }

            this.$router.push({
                name: 'logger-type-edit',
                params: { id: type.id }
            });
        }

        get userIsAdmin(){

            return [UserRole.ADMIN].indexOf(this.$user.role) >= 0;
        }
    }

</script>
